export * from './header/header.component';
export * from './header-clear/header-clear.component';
export * from './footer/footer.component';
export * from './search-input/search-input.component';
export * from './tiny-mce/tiny-mce.component';
export * from './theme-settings/theme-settings.component';
export * from './theme-switcher/theme-switcher.component';



// WEBPACK FOOTER //
// /Users/gmdimitriz/Projects/minha-loga/src/app/@theme/components/index.ts